import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledRspImageBg = styled.div`
	${props => props.styles}
	position: relative;
	background-image: url(${props => props.img});
`;

const StyledPlaceholder = styled.div`
	position: absolute;
	top: 4px; right: 4px;
	bottom: 4px; left: 4px;
	background-image: url(${props => props.placeholder});
	background-size: cover;
	background-position: 50% 50%;
	filter: blur(4px);
	z-index: -1;
`;

export const RspImageBg = ({
	image,
	mobileWidth,
	mobileHeight,
	tabletWidth,
	tabletHeight,
	desktopWidth,
	desktopHeight,
	desktopHugeWidth,
	desktopHugeHeight,
	retinaWidth,
	retinaHeight,
	attributes,
	styles,
	children,
	...properties
}) => {
	const isPictureSupported = !!window.HTMLPictureElement;
	const placeholder = encodeURI(image.replace('{width}', '100').replace('{height}', '0'));
	const [img, setImg] = useState('');

	const onImageLoad = (e) => {
		let src = e.target.currentSrc !== 'undefined' ? e.target.currentSrc : e.target.src;

		if(!isPictureSupported) {
			src = encodeURI(image.replace('{width}', '1920').replace('{height}', '0'));
		}

		if(img !== src) setImg(src);
	};

	const onImageError = () => {
		// TODO: Set a better one
		setImg('/assets/images/placeholder.jpg');
	};

	return (
		<StyledRspImageBg styles={styles} {...properties} img={img}>
			<StyledPlaceholder placeholder={placeholder} />
			<picture style={{ display: 'none' }}>
				<source media="(min-width: 2561)" srcSet={encodeURI(image.replace('{width}', retinaWidth).replace('{height}', retinaHeight)) + (attributes)} />
				<source media="(min-width: 1921px)" srcSet={encodeURI(image.replace('{width}', desktopHugeWidth).replace('{height}', desktopHugeHeight)) + (attributes)} />
				<source media="(min-width: 1024px)" srcSet={encodeURI(image.replace('{width}', desktopWidth).replace('{height}', desktopHeight)) + (attributes)} />
				<source media="(min-width: 480px)" srcSet={encodeURI(image.replace('{width}', tabletWidth).replace('{height}', tabletHeight)) + (attributes)} />
				<source media="" srcSet={encodeURI(image.replace('{width}', mobileWidth).replace('{height}', mobileHeight)) + (attributes)} />
				<img
					style={{ display: 'none' }}
					src={encodeURI(image.replace('{width}', desktopWidth).replace('{height}', desktopHeight)) + (attributes)}
					alt={image}
					onError={onImageError}
					onLoad={onImageLoad} />
			</picture>
			{children}
		</StyledRspImageBg>
	);
};

RspImageBg.propTypes = {
	image: PropTypes.string.isRequired,
	attributes: PropTypes.string,
	retinaWidth: PropTypes.string,
	desktopHugeWidth: PropTypes.string,
	desktopWidth: PropTypes.string,
	tabletWidth: PropTypes.string,
	mobileWidth: PropTypes.string,
	retinaHeight: PropTypes.string,
	desktopHugeHeight: PropTypes.string,
	desktopHeight: PropTypes.string,
	tabletHeight: PropTypes.string,
	mobileHeight: PropTypes.string
};

RspImageBg.defaultProps = {
	attributes: '',
	retinaWidth: '3840',
	desktopHugeWidth: '2560',
	desktopWidth: '1920',
	tabletWidth: '1024',
	mobileWidth: '480',
	retinaHeight: '0',
	desktopHugeHeight: '0',
	desktopHeight: '0',
	tabletHeight: '0',
	mobileHeight: '0'
};

export default RspImageBg;
